module.exports = __webpack_public_path__ + "img/free-fire-1.c57b81c7.png";